import { ASSET_DESKTOP, ASSET_MOBILE } from '../elements/assets'

export const CONTEXT_SOURCES = `
...on contextSources_Entry {
  id
  typeHandle

  heading: headingAdvanced {
    html
  }
  description

  ${ ASSET_DESKTOP }
  ${ ASSET_MOBILE }

  items: contextSourcesItems {
    id
    title
    description
    labels {
      title
      color: labelColor
    }
  }
}
`